import { t } from "i18next";
import { Button, Col, Container, Form, Modal, Row } from "react-bootstrap";
import { useEffect, useState } from "react";
import { Club } from "../../../../interfaces/club";
import { createStaff } from "../../../../services/staff";
import Uploader from "../../../general/uploader";
import { Media } from "../../../../interfaces/media";
import { countriesList } from "../../../../data/countries";
import { getTeamOptions } from "../../../../services/team";
import { roleOptions } from "../../../../data/roles";

interface AdminStaffNewProps {
    onSave: CallableFunction;
    onClose: CallableFunction;
}

export function AdminStaffNew(props: AdminStaffNewProps) {
    const [teamOptions, setTeamOptions] = useState<Club[]>([]);
    const [media, setMedia] = useState<Media[]>([]);

    useEffect(() => {
        getTeamOptions()
            .then(response => {
                setTeamOptions(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }, []);

    const handleSave = (event: any) => {
        event.preventDefault();

        const body = {
            first_name: event.target.first_name.value,
            last_name: event.target.last_name.value,
            email: event.target.email.value,
            phone: event.target.phone.value,
            document_id: event.target.document_id.value,
            birthdate: event.target.birthdate.value,
            description: event.target.description.value,
            avatar: media,
            status: 1,
            birth_city: event.target.birth_city.value,
            birth_region: event.target.birth_region.value,
            birth_country: event.target.birth_country.value,
            address: event.target.address.value,
            city: event.target.city.value,
            region: event.target.region.value,
            country: event.target.country.value,
            role: event.target.role.value
        }
        createStaff(body)
            .then(response => {
                if (response.data.status == 1) {
                    props.onSave(response.data.data);
                } else {
                    alert(response.data.message);
                }
            })
            .catch(error => {
                console.log(error);
            });
    }
    
    const handleClose = () => {
        props.onClose();
    }

    const handleMediaEventUpload = (media: Media[]) => {
        if (media.length > 1) {
            alert(t("single_image_warning"));
        } else {
            const newMedia = media.map((m: Media) => { return m; });
            setMedia(newMedia);
        }
    }

    return (
        <Modal className="admin-staff-new-container" show={ true }
            onHide={ handleClose } size="xl"> 
            <Modal.Header closeButton>
                <Modal.Title>
                    { t("New coach") }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={ handleSave }>
                    <div className="fields">
                        <Container>
                            <Row>
                                <Col xs={12} md={8}>
                                    <Row>
                                        <Col xs={12} md={6}>
                                        <Form.Group className="mb-3" controlId="first_name">
                                            <Form.Label aria-required="true">{ t("first_name") }</Form.Label>
                                            <Form.Control type="text" name="first_name" required />
                                        </Form.Group>
                                        </Col>
                                        <Col xs={12} md={6}>
                                            <Form.Group className="mb-3" controlId="last_name">
                                                <Form.Label aria-required="true">{ t("last_name") }</Form.Label>
                                                <Form.Control type="text" name="last_name" required />
                                            </Form.Group>
                                        </Col>
                                        <Col xs={12} md={6}>
                                            <Form.Group className="mb-3" controlId="email">
                                                <Form.Label aria-required="true">{ t("email") }</Form.Label>
                                                <Form.Control type="email" name="email" required />
                                            </Form.Group>
                                        </Col>
                                        <Col xs={12} md={6}>
                                            <Form.Group className="mb-3" controlId="phone">
                                                <Form.Label>{ t("phone") }</Form.Label>
                                                <Form.Control type="text" name="phone" />
                                            </Form.Group>
                                        </Col>
                                        <Col xs={12} md={6}>
                                            <Form.Group className="mb-3" controlId="document_id">
                                                <Form.Label>{ t("document_id") }</Form.Label>
                                                <Form.Control type="text" name="document_id" />
                                            </Form.Group>
                                        </Col>
                                        <Col xs={12} md={6}>
                                            <Form.Group className="mb-3" controlId="birthdate">
                                                <Form.Label>{ t("birthdate") }</Form.Label>
                                                <Form.Control type="date" name="birthdate" />
                                            </Form.Group>
                                        </Col>
                                        <Col xs={12}>
                                            <Form.Group className="mb-3" controlId="description">
                                                <Form.Label>{ t("description") }</Form.Label>
                                                <Form.Control name="description" as="textarea" rows={5} />
                                            </Form.Group>
                                        </Col>
                                        <Col xs={12}>
                                            <Form.Group className="mb-3 media-field" controlId="media">
                                                <Uploader title={ t("avatar_upload_message") }
                                                    media={ media } save={ handleMediaEventUpload } />
                                            </Form.Group>
                                        </Col>
                                        <Col xs={12} md={6}>
                                            <Form.Group className="mb-3" controlId="role">
                                                <Form.Label aria-required="true">{ t("role") }</Form.Label>
                                                <Form.Select aria-label={ t("role") }>
                                                    <option value="">{ t("select_role") }</option>
                                                    { roleOptions.map((r: any) => {
                                                        if (['badminton_coach'].includes(r.value)) {
                                                            return <option key={ 'role-' + r.value } value={r.value}>{ t(r.label) }</option>
                                                        }
                                                    })}
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        {/*<Col xs={12}>
                                            <Form.Check
                                                type="switch"
                                                name="status"
                                                label={ t("staff_status_switch_label") }
                                                defaultChecked={ false }
                                                id="status-switch"
                                            />
                                        </Col>*/}
                                    </Row>
                                </Col>
                                <Col xs={12} md={4} style={ { borderLeft: '1px solid #000;'} }>
                                    <div className="left mt-3">
                                        <fieldset className="mb-4" >
                                            <legend>{ t("birth_place") }</legend>
                                            <div>
                                            <Form.Group className="mb-2" controlId="birth_city">
                                                <Form.Label>{ t("birth_city") }</Form.Label>
                                                <Form.Control type="text" name="birth_city" />
                                            </Form.Group>
                                            <Form.Group className="mb-2" controlId="birth_region">
                                                <Form.Label>{ t("birth_region") }</Form.Label>
                                                <Form.Control type="text" name="birth_region" />
                                            </Form.Group>
                                            <Form.Group className="mb-2" controlId="birth_country">
                                                <Form.Label>{ t("birth_country") }</Form.Label>
                                                <Form.Select aria-label={ t("country") } name="birth_country">
                                                    <option value="">{ t("select_country") }</option>
                                                    { countriesList.map((c: any) => {
                                                        return <option key={ 'birth-country-' + c.code }
                                                            value={ c.code }>{ c.name }</option>
                                                    })}
                                                </Form.Select>
                                            </Form.Group>
                                            </div>
                                        </fieldset>
                                        <fieldset className="">
                                            <legend>{ t("residence_place") }</legend>
                                            <div>
                                                <Form.Group className="mb-2" controlId="address">
                                                    <Form.Label>{ t("address") }</Form.Label>
                                                    <Form.Control type="text" name="address" />
                                                </Form.Group>
                                                <Form.Group className="mb-2" controlId="city">
                                                    <Form.Label>{ t("city") }</Form.Label>
                                                    <Form.Control type="text" name="city" />
                                                </Form.Group>
                                                <Form.Group className="mb-2" controlId="region">
                                                    <Form.Label>{ t("region") }</Form.Label>
                                                    <Form.Control type="text" name="region" />
                                                </Form.Group>
                                                <Form.Group className="mb-2" controlId="country">
                                                    <Form.Label>{ t("country") }</Form.Label>
                                                    <Form.Select aria-label={ t("countries") } name="country">
                                                        <option value="">{ t("select_country") }</option>
                                                        { countriesList.map((c: any) => {
                                                            return <option key={ 'country-' + c.code }
                                                                value={ c.code }>{ c.name }</option>
                                                        })}
                                                    </Form.Select>
                                                </Form.Group>
                                            </div>
                                        </fieldset>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                    <div className="actions">
                        <Button type="submit" variant="primary">
                            { t("Save") }
                        </Button>
                        <Button variant="secondary" onClick={ handleClose }>
                            { t("Close") }
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
}